





























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import PropertyDisplayer from '@/components/Utils/PropertyDisplayer.vue';

@Component({
  components: {PropertyDisplayer},
})
export default class SafeUpdateSettings extends Vue {

  @Prop({default: true})
  private safe!: boolean;

  /* v-checkbox bind on safe property does not work at initial state */
  private safeInternal: boolean = true;

  @Prop({default: ''})
  private hostGuess!: string;

  @Prop({default: ''})
  private host!: string;

  @Prop({default: false})
  private reverse!: boolean;

  private hostForced: boolean = false;

  private forcedHost: string | null = null;

  @Watch('safe')
  private onSafePropChanged() {
    this.safeInternal = this.safe;
  }

  @Watch('hostGuess')
  private onHostChanged() {
    this.sendHostUpdate();
  }

  @Watch('hostForced')
  private onHostForcedChanged() {
    this.sendHostUpdate();
  }

  @Watch('forcedHost')
  private onForcedHostChanged() {

    if (this.forcedHost === null) {
      this.hostForced = false;
    }

    this.sendHostUpdate();
  }

  private sendHostUpdate() {
    this.$emit('update:host', this.hostForced ? this.forcedHost : this.hostGuess);
  }

  private onSafeChanged(event: any) {
    this.$emit('update:safe', this.safeInternal);
  }

  private forceHost() {
    this.host = this.hostGuess;
    this.hostForced = true;
    this.forcedHost = this.host;
  }
}
